import React from 'react'
import { Grid } from '@material-ui/core'
import { CollectionHeaderRow, CollectionRow } from './CollectionRow'
import {
  ImportCollectionStatus,
  MigrationCollections,
  MigrationStatus,
} from '../../../../types/migration'

interface CompanyCollectionsGroupProps {
  migrationCompanyStatus: MigrationStatus
  isCompanyCollectionSelected: boolean
  isBrandCollectionSelected: boolean
  isVendorCollectionSelected: boolean
  isNotExportableCollection: boolean
  isNotExportableCompanyLevelCollection: boolean
  isLoading: boolean
  isCompanySelected: boolean
  isImportStatusLoading: boolean
  onCompanyDetailsModalOpen: () => void
  onCollectionDetailsModalOpen: (collectionName: MigrationCollections) => void
  onCompanyCollectionToggle: () => void
  onBrandCollectionToggle: () => void
  onVendorCollectionToggle: () => void
  getImportStatusByCollection: (
    collection: MigrationCollections,
  ) => ImportCollectionStatus | undefined
  onImportDetailsOpen: (collection: MigrationCollections) => void
}

export const CompanyCollectionsGroup: React.FC<CompanyCollectionsGroupProps> = ({
  migrationCompanyStatus,
  isCompanyCollectionSelected,
  isBrandCollectionSelected,
  isVendorCollectionSelected,
  isNotExportableCollection,
  isNotExportableCompanyLevelCollection,
  isCompanySelected,
  isLoading,
  isImportStatusLoading,
  onCompanyDetailsModalOpen,
  onCollectionDetailsModalOpen,
  onCompanyCollectionToggle,
  onBrandCollectionToggle,
  onVendorCollectionToggle,
  getImportStatusByCollection,
  onImportDetailsOpen,
}) => {
  const brandImportStatus = getImportStatusByCollection(MigrationCollections.Brands)
  const vendorImportStatus = getImportStatusByCollection(MigrationCollections.Vendors)

  return (
    <Grid container direction="column" spacing={8}>
      <Grid item>
        <CollectionHeaderRow />
      </Grid>
      <Grid item>
        <CollectionRow
          migrationStatus={migrationCompanyStatus}
          onDetailsModalOpen={onCompanyDetailsModalOpen}
          collectionName={MigrationCollections.Company}
          isCollectionSelected={isCompanyCollectionSelected}
          toggleSelected={onCompanyCollectionToggle}
          disabled={isLoading || !isCompanySelected}
        />
      </Grid>
      <Grid item>
        <CollectionRow
          migrationStatus={migrationCompanyStatus}
          onDetailsModalOpen={onCollectionDetailsModalOpen}
          collectionName={MigrationCollections.Shops}
          isCollectionSelected={isCompanyCollectionSelected}
          toggleSelected={onCompanyCollectionToggle}
        />
      </Grid>
      <Grid item>
        <CollectionRow
          migrationStatus={migrationCompanyStatus}
          onDetailsModalOpen={onCollectionDetailsModalOpen}
          collectionName={MigrationCollections.Employees}
          isCollectionSelected={isCompanyCollectionSelected}
          toggleSelected={onCompanyCollectionToggle}
        />
      </Grid>
      <Grid item>
        <CollectionRow
          migrationStatus={migrationCompanyStatus}
          onDetailsModalOpen={onCollectionDetailsModalOpen}
          collectionName={MigrationCollections.Brands}
          isCollectionSelected={isBrandCollectionSelected}
          toggleSelected={onBrandCollectionToggle}
          disabled={isNotExportableCompanyLevelCollection}
          importStatus={brandImportStatus}
          isImportAvailable={Boolean(brandImportStatus)}
          onImportDetailsOpen={onImportDetailsOpen}
          isImportStatusLoading={isImportStatusLoading}
        />
      </Grid>
      <Grid item>
        <CollectionRow
          migrationStatus={migrationCompanyStatus}
          onDetailsModalOpen={onCollectionDetailsModalOpen}
          collectionName={MigrationCollections.Vendors}
          isCollectionSelected={isVendorCollectionSelected}
          toggleSelected={onVendorCollectionToggle}
          disabled={isNotExportableCompanyLevelCollection}
          importStatus={vendorImportStatus}
          isImportAvailable={Boolean(vendorImportStatus)}
          onImportDetailsOpen={onImportDetailsOpen}
          isImportStatusLoading={isImportStatusLoading}
        />
      </Grid>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/CompanyCollectionsGroup.tsx